import MarkEmailReadOutlinedIcon from '@mui/icons-material/MarkEmailReadOutlined';
import ForwardToInboxOutlinedIcon from '@mui/icons-material/ForwardToInboxOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import RuleOutlinedIcon from '@mui/icons-material/RuleOutlined';
import TaskOutlinedIcon from '@mui/icons-material/TaskOutlined';
import { ReactComponent as ApprovalDelegationIcon } from '../../assets/icons/approval-delegation.svg';
import {
  Folder,
  FolderAndSubFolderCaptions,
  FoldersSubFolder,
  FolderWithSubFolders,
} from '../../models/communication.types';
import { fillBlue } from '../../utils/contrastSvgAttributes';

const messagesSubFolder: FoldersSubFolder[] = [
  {
    id: Folder.Received,
    icon: <MarkEmailReadOutlinedIcon style={{ width: '20px' }} />,
    text: 'Odebrane',
  },
  {
    id: Folder.Sent,
    icon: <ForwardToInboxOutlinedIcon style={{ width: '20px' }} />,
    text: 'Wysłane',
  },
  {
    id: Folder.Removed,
    icon: <DeleteOutlinedIcon style={{ width: '20px' }} />,
    text: 'Usunięte',
  },
];

const specialCasesSubFolder: FoldersSubFolder[] = [
  {
    id: Folder.SpecialCasesToSolve,
    icon: (
      <ApprovalDelegationIcon
        fill={fillBlue}
        style={{ width: '18px', marginLeft: '2px' }}
        title="ikona szególne przypadki"
      />
    ),
    text: 'Do rozwiązania',
  },
  {
    id: Folder.SpecialCasesSolved,
    icon: <CheckCircleOutlineOutlinedIcon style={{ width: '20px' }} />,
    text: 'Rozwiązane',
  },
];

const helpDeskSubFolder: FoldersSubFolder[] = [
  {
    id: Folder.HelpdeskReported,
    icon: <RuleOutlinedIcon style={{ width: '20px' }} />,
    text: 'Zgłoszone',
  },
  {
    id: Folder.HelpdeskSolved,
    icon: <TaskOutlinedIcon style={{ width: '20px' }} />,
    text: 'Rozwiązane',
  },
];

export const folders: FolderWithSubFolders[] = [
  {
    name: 'Wiadomości',
    items: messagesSubFolder,
  },
  {
    name: 'Szczególne przypadki',
    items: specialCasesSubFolder,
  },
  {
    name: 'Helpdesk',
    items: helpDeskSubFolder,
  },
];

export const getFolderAndSubFoldersCaptions = (subFolderId: Folder): FolderAndSubFolderCaptions => {
  const result: FolderAndSubFolderCaptions = { folder: null, subFolder: null };
  folders.forEach((folder) => {
    folder.items.forEach((subFolder) => {
      if (subFolder.id === subFolderId) {
        result.folder = folder.name;
        result.subFolder = subFolder.text;
      }
    });
  });

  return result;
};

export const decodeHtmlEntities = (str: string) => {
  const txt = document.createElement('textarea');
  txt.innerHTML = str;
  return txt.value;
};
